export default "__VITE_ASSET__ELW1K2g5__"